import format from 'date-fns/format';

export const REG_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const getIsEmailValid = (email) => REG_EMAIL.test(email);

export const wait = (delay) => new Promise((resolve) => setTimeout(() => resolve(), delay));

export const formatDate = (date, formatType) => format(date, formatType);

export const isSomeOf = (array, check) => array.some((elem) => elem === check);

export const debounce = (func, delay) => {
  let timeout;
  return (...args) => {
    const later = () => {
      timeout = null;
      return func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, delay);
  };
};

/** Замена подстроки в строке */
export const replaceSubstring = (string, keyword, replaced) => {
  if (typeof string === 'string') {
    return string.replace(keyword, replaced);
  }
  return string;
};

export const isEmptyValue = (value) => ['', null, undefined, '{}'].includes(value) === true
  || (Array.isArray(value) === true && value.length === 0)
  || (typeof value === 'object' && Object.keys(value).length === 0);

export const getNotificationPointsBlockEnabled = () => window?.notificationPointsBlockEnabled;
